<template>
  <div style="padding:30px;">
      <a-select v-model="timemethod" placeholder="请选择" @change="choose_method" >
          <a-select-option
            v-for="item in optionsTimeSelectMethond"
            :key="item.value"
            >{{item.label}}</a-select-option>
        </a-select>

         <span v-show="timemethod=='absolute'" >
           <a-date-picker
             v-model="absoluterRange"
             type="datetimerange"
             :picker-options="pickerOptions"
             range-separator="至"
             start-placeholder="开始日期"
             end-placeholder="结束日期"
            @change="info"  >
           </a-date-picker>
         </span>

    <span v-show="timemethod=='relative'">
      <a-select v-model="timerange" placeholder="请选择" @change="use_relative" >
          <a-select-option
            v-for="item in optionsRelativeTime"
            :key="item.value"
            >{{item.label}}</a-select-option>
        </a-select>
     </span>
<br>
<iframe :src=urlBrokerTpsAndQps  width="50%" height="350" frameborder="0"></iframe>
<iframe :src=urlMessageDelay  width="50%" height="350" frameborder="0"></iframe>
<iframe :src=urlProducerTps  width="50%" height="350" frameborder="0"></iframe>
<iframe :src=urlConsumerTps  width="50%" height="350" frameborder="0"></iframe>
<iframe :src=urlProducerSize  width="50%" height="350" frameborder="0"></iframe>
<iframe :src=urlConsumerSize  width="50%" height="350" frameborder="0"></iframe>
</div>
</template>

<script>
export default {
    mounted() {
        console.log('@@@@@@@@@@@@@@@@@@@@@@@@')
    },

    methods: {
        use_relative() {
            this.absolue=false
        },
        choose_method(){
            if (this.timemethod == "relative" ){
                this.use_relative()
            }
        },
        info(){
            this.absolue=true
            console.log("---------------")
            console.log(this.absoluterRange[0].getTime())
            console.log(this.urlN)
            console.log("---------------")
        }
    },
    computed:{
        defautl_range(){
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
        },

        urlBrokerTpsAndQps(){
            var urlRoot = this.grafanaUrlRoot + "rocketmqjian-kong?orgId=1&refresh=30s&var-envredisname=" + this.envredisname
            if (this.absolue){
                let start = this.absoluterRange[0].getTime()
                let end = this.absoluterRange[1].getTime()
                return  urlRoot + "&var-env=v3&var-master_address=All&from="+ start +"&to="+ end+ "&panelId=6"
            }
            return  urlRoot + "&var-env=v3&var-master_address=All&"+ this.timerange + " &panelId=6"
        },
        urlMessageDelay(){
            var urlRoot = this.grafanaUrlRoot + "rocketmqjian-kong?orgId=1&refresh=30s&var-envredisname=" + this.envredisname
            if (this.absolue){
                let start = this.absoluterRange[0].getTime()
                let end = this.absoluterRange[1].getTime()
                return  urlRoot + "&var-env=v3&var-master_address=All&from="+ start +"&to="+ end+ "&panelId=4"
            }
            return  urlRoot + "&var-env=v3&var-master_address=All&"+ this.timerange + " &panelId=4"
        },
        urlProducerTps(){
            var urlRoot = this.grafanaUrlRoot + "rocketmqjian-kong?orgId=1&refresh=30s&var-envredisname=" + this.envredisname
            if (this.absolue){
                let start = this.absoluterRange[0].getTime()
                let end = this.absoluterRange[1].getTime()
                return  urlRoot + "&var-env=v3&var-master_address=All&from="+ start +"&to="+ end+ "&panelId=8"
            }
            return  urlRoot + "&var-env=v3&var-master_address=All&"+ this.timerange + " &panelId=8"
        },
        urlConsumerTps(){
            var urlRoot = this.grafanaUrlRoot + "rocketmqjian-kong?orgId=1&refresh=30s&var-envredisname=" + this.envredisname
            if (this.absolue){
                let start = this.absoluterRange[0].getTime()
                let end = this.absoluterRange[1].getTime()
                return  urlRoot + "&var-env=v3&var-master_address=All&from="+ start +"&to="+ end+ "&panelId=20"
            }
            return  urlRoot + "&var-env=v3&var-master_address=All&"+ this.timerange + " &panelId=20"
        },
        urlProducerSize(){
            var urlRoot = this.grafanaUrlRoot + "rocketmqjian-kong?orgId=1&refresh=30s&var-envredisname=" + this.envredisname
            if (this.absolue){
                let start = this.absoluterRange[0].getTime()
                let end = this.absoluterRange[1].getTime()
                return  urlRoot + "&var-env=v3&var-master_address=All&from="+ start +"&to="+ end+ "&panelId=12"
            }
            return  urlRoot + "&var-env=v3&var-master_address=All&"+ this.timerange + " &panelId=12"
        },
        urlConsumerSize(){
            var urlRoot = this.grafanaUrlRoot + "rocketmqjian-kong?orgId=1&refresh=30s&var-envredisname=" + this.envredisname
            if (this.absolue){
                let start = this.absoluterRange[0].getTime()
                let end = this.absoluterRange[1].getTime()
                return  urlRoot + "&var-env=v3&var-master_address=All&from="+ start +"&to="+ end+ "&panelId=22"
            }
            return  urlRoot + "&var-env=v3&var-master_address=All&"+ this.timerange + " &panelId=22"
        },
    },
    data() {
        return {
            grafanaUrlRoot: "http://172.19.233.39:3000/d-solo/WQS4SOFMz/",
            timemethod: "relative",
            optionsTimeSelectMethond: [{
                value: 'relative',
                label: '相对时间选择'
            }, {
                value: 'absolute',
                label: '绝对时间选择'
            }],

            pickerOptions: {
                shortcuts: [{
                    text: '最近两天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            absoluterRange: '',
            absolue: false,



            optionsRelativeTime: [{
                value: '&from=now-5m&to=now',
                label: 'Last 5 miniutes'
            }, {
                value: '&from=now-15m&to=now',
                label: 'Last 15 miniutes'
            }, {
                value: '&from=now-30m&to=now',
                label: 'Last 30 miniutes'
            }, {
                value: '&from=now-1h&to=now',
                label: 'Last 1 hour'
            }, {
                value: '&from=now-3h&to=now',
                label: 'Last 3 hours'
            },{
                value: '&from=now-6h&to=now',
                label: 'Last 6 hours'
            },{
                value: '&from=now-12h&to=now',
                label: 'Last 12 hours'
            },{
                value: '&from=now-24h&to=now',
                label: 'Last 24 hours'
            },{
                value: '&from=now-2d&to=now',
                label: 'Last 2 days'
            },{
                value: '&from=now-7d&to=now',
                label: 'Last 7 days'
            },{
                value: '&from=now-30d&to=now',
                label: 'Last 30 days'
            },
            ],
            timerange: '&from=now-3h&to=now',
        }
    }
}
</script>
